<!--
 * @Author: Lemon C
 * @Date: 2024-05-15 17:53:10
 * @LastEditTime: 2025-03-11 14:57:48
-->
<template>
    <div class="sup-search-tree">
        <div class="docs-tree-box">
            <el-tree
                :data="treeList"
                ref="ref_eltree"
                :props="defaultProps"
                :default-expanded-keys="expandedKeys"
                :default-expand-all="true"
                highlight-current
                :expand-on-click-node="false"
                @node-click="eltree_node_click"
                node-key="id">
                <template #default="{ node, data }">
                    <div class="custom-tree-node" :scroll-node-key="data.id">
                        <div class="node-content-box">
                            {{ node.label }}
                        </div>
                        <div class="node-num">{{ data.count }}</div>
                    </div>
                </template>
            </el-tree>
        </div>
    </div>
</template>

// MOD-- JavaScript
<script setup>
import { ref, onMounted, watch, nextTick, getCurrentInstance } from 'vue';

const { proxy } = getCurrentInstance();

const props = defineProps({
    tree_list: Array,
    tree_node_callback: Function,
    tree_sel_type: Number,
});

const ref_eltree = ref(null);
const treeList = ref([]);
const defaultProps = ref({
    children: 'subCatalogs',
    label: 'name',
}); //目录树别名
const expandedKeys = ref([]); //目录树展开id

watch(
    () => props.tree_list,
    () => {
        treeList.value = props.tree_list;
        eltree_auto_loc();
    },
    {
        deep: true,
    }
);

onMounted(() => {
    treeList.value = props.tree_list;
    eltree_auto_loc();
    console.log('搜索目录树选中类型： ' + props.tree_sel_type);
});

// MARK Tree  自动定位
const eltree_auto_loc = () => {
    if (props.tree_sel_type && props.tree_sel_type != proxy.$globalObj.docs_switch.all) {
        let findData = find_tree_node(treeList.value, 'type', props.tree_sel_type);
        if (findData && findData.count > 0) {
            expandedKeys.value.push(findData.id);
            nextTick(() => {
                ref_eltree.value.setCurrentKey(findData.id);
            });
            eltree_node_click(findData);
        } else {
            eltree_recursion_node(treeList.value);
        }
    } else {
        eltree_recursion_node(treeList.value);
    }
};

// MARK Tree  递归默认展开
const eltree_recursion_node = (treeList) => {
    if (treeList[0].subCatalogs && treeList[0].subCatalogs.length) {
        eltree_recursion_node(treeList[0].subCatalogs);
    } else {
        let selTreeData = treeList[0];
        expandedKeys.value.push(selTreeData.id);
        nextTick(() => {
            ref_eltree.value.setCurrentKey(selTreeData.id);
        });
        eltree_node_click(selTreeData);
    }
};

// MARK el-tree  节点点击
const eltree_node_click = (data, node, el) => {
    props.tree_node_callback(data, treeList.value);
};

// MARK Find 多级数组嵌套查询对象
const find_tree_node = (array, field, value) => {
    for (let i = 0; i < array.length; i++) {
        const obj = array[i];
        if (obj[field] === value) {
            return obj;
        } else if (obj.subCatalogs) {
            const result = find_tree_node(obj.subCatalogs, field, value);
            if (result) {
                return result;
            }
        }
    }
    return null;
};
</script>

// MOD-- CSS
<style lang="less" scoped>
.sup-search-tree {
    position: relative;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    overflow: hidden;
    box-sizing: border-box;
    padding-right: 18px;
    box-sizing: border-box;
    border-right: 1px solid var(--color-main-doc-segmentation-line-bg);
    user-select: none;

    :deep(.docs-tree-box) {
        display: flex;
        position: relative;
        margin: 15px 0px 0px 30px;
        padding: 0px 20px 0px 0px;
        box-sizing: border-box;
        overflow-y: auto;

        .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
            box-sizing: border-box;
            border-left: 3px solid var(--color-main-brand);
            background: var(--color-main-brand-hover-light);
            border-radius: 2px;

            .node-num {
                background: var(--color-main-brand);
                color: var(--color-main-text-brand-bg-primary);
            }
        }

        .el-tree {
            position: relative;
            width: 100%;

            .el-tree-node__content {
                height: unset !important;
                margin-top: 4px;
                box-sizing: border-box;
                border-left: 3px solid var(--color-main-border-transparent);

                &:hover {
                    background: var(--color-main-brand-hover-light);
                    border-radius: 2px;

                    .node-num {
                        background: var(--color-main-brand);
                        color: var(--color-main-text-brand-bg-primary);
                    }
                }

                .el-tree-node__expand-icon {
                    display: none;
                }
            }

            .custom-tree-node {
                position: relative;
                display: flex;
                flex: 1;
                padding: 0px 16px 0px 6px;
                box-sizing: border-box;
                flex-shrink: 0;
                align-items: center;
                height: 36px;
                margin-left: 30px;

                .node-content-box {
                    position: relative;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    align-items: center;
                    font-weight: 400;
                    color: var(--color-main-text-primary);
                    font-size: 16px;
                    line-height: 24px;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .node-num {
                    position: relative;
                    width: 40px;
                    height: 22px;
                    background: var(--color-main-brand-hover-light);
                    border-radius: 1px;
                    font-weight: 400;
                    font-size: 14px;
                    color: var(--color-main-brand);
                    line-height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
            }
        }
    }
}
</style>
